import React from 'react';

import { Panel } from '../../../../../components/panel/Panel';

// dummy
export const DepartmentsTabPanel: React.FC = () => {
  return <Panel>departments</Panel>;
};
